module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/vn-25540177a9e64be64b71d743cec8a669.svg";